// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2wxre","label":"CategoryService_label__ONKsB","location":"CategoryService_location__2FnZ9"};